/* eslint-disable prettier/prettier */
import React, { useState } from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import cloneDeep from 'lodash/cloneDeep';
import {
	UncontrolledButtonDropdown,
	DropdownMenu,
	DropdownItem,
	DropdownToggle,
	Col,
	UncontrolledTooltip,
} from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import { showAlerta } from '@common/common.action';
import { quadroKanbanEnum } from '@common/util/defaultValues';
import ModalMoverLote from './modal';
import ModalOrganizarLote from './organizarLote/modal';
import * as kanbanActions from './store/kanban.action';
import * as organizarActions from './organizarLote/store/organizar.action';
import './style.css';

import IntlMessage from "../../helpers/intlMessage";

function DragDropComponente(props) {
	const dispatch = useDispatch();

	const showModal = useSelector((state) => state.kanban.modal);
	const showModalOrganizarLote = useSelector(
		(state) => state.organizarLote.modal
	);
	const [items, setItems] = useState([]);
	const [destinos, setDestinos] = useState([]);

	function onDragEnd(result) {
		if (typeof props.onDragEndOverride === 'function') {
			props.onDragEndOverride(result);
		} else {
			const { source, destination } = result;

			if (!destination) {
				return;
			}

			const list = cloneDeep(props.list);

			if (source.droppableId === destination.droppableId) {
				reorder(list, source.droppableId, source.index, destination.index);
				props.update(list, result.draggableId, destination.droppableId);
			} else {
				move(list, source, destination);
				props.update(list, result.draggableId, destination.droppableId);
			}
		}
	}

	function reorder(list, droppableId, startIndex, endIndex) {
		const origem = list.find((i) => Object.keys(i)[0] === droppableId);
		const removed = origem[droppableId].splice(startIndex, 1)[0];

		origem[droppableId].splice(endIndex, 0, removed);
	}

	function move(list, droppableSource, droppableDestination) {
		const origem = list.find(
			(i) => Object.keys(i)[0] === droppableSource.droppableId
		);
		const destino = list.find(
			(i) => Object.keys(i)[0] === droppableDestination.droppableId
		);
		const removed = origem[droppableSource.droppableId].splice(
			droppableSource.index,
			1
		)[0];

		destino[droppableDestination.droppableId].splice(
			droppableDestination.index,
			0,
			removed
		);
	}

	function montarColunas(list, origin) {
		const colunas = [];
		list.map((item) => {
			if (origin !== Object.keys(item)[0]) {
				colunas.push({
					label: item.title.text,
					value: Object.keys(item)[0],
				});
			}
			return colunas;
		});
		return colunas;
	}

	const grid = 1;

	const getListStyle = (isDraggingOver) => ({
		background: isDraggingOver ? 'lightblue' : 'transparent',
		padding: grid,
		width: `${100 / props.list.length}%`,
	});

	const getItemStyle = (isDragging, draggableStyle, conformidade) => ({
		minHeight: '110px',
		userSelect: 'none',
		padding: '12px 8px',
		margin: `0 0 ${grid}px 0`,
		background: isDragging ? 'lightgreen' : '#ffffff',
		borderLeft: `4px solid ${conformidade ? 'red' : 'green'}`,
		position: 'relative',
		cursor: conformidade ? 'no-drop' : 'pointer',
		...draggableStyle,
	});

	const getTitleStyle = (color) => ({
		background: color,
		color: color.includes('fff') ? '#000' : '#ffffff',
		padding: '12px',
		fontSize: '18px',
		fontWeight: 700,
		height: '50px',
		lineHeight: '25px',
		textAlign: 'center',
		position: 'relative',
	});

	const getCountStyle = () => ({
		top: '4px',
		fontSize: '11px',
		backgroundColor: '#17a2b8',
		padding: '3px',
		borderRadius: '50%',
		position: 'absolute',
		minWidth: '21px',
		height: '21px',
		lineHeight: '15px',
	});

	const ativarMoverLote = true;

	const onClikItem = (item) => {
		if (item.count > 0) {
			const colunas = montarColunas(props.list, Object.keys(item)[0]);
			setDestinos(colunas);
			setItems(item);
			dispatch(kanbanActions.atualizarModal(true));
		} else {
			dispatch(showAlerta('erro', <IntlMessage id = "dashboards.cytology.noItemsSend"/>, 1500));
		}
	};

	return (
		<React.Fragment>
			<ModalOrganizarLote
				lista={props.list}
				onModal={() =>
					dispatch(organizarActions.atualizarModal(!showModalOrganizarLote))
				}
				showModal={showModalOrganizarLote}
				data={[]}
				backdrop
			/>
			<ModalMoverLote
				lista={props.list}
				periodoFinal={props.periodoFinal}
				periodoInicial={props.periodoInicial}
				onChangePeriodo={props.onChangePeriodo}
				buscar={props.buscar}
				onModal={() => dispatch(kanbanActions.atualizarModal(!showModal))}
				showModal={showModal}
				data={items}
				destinos={destinos}
				backdrop
			/>
			<DragDropContext onDragEnd={(e) => onDragEnd(e)}>
				{props.list.map((item, i) => (
					<Droppable
						key={`col_${i}_${item.id}`}
						droppableId={Object.keys(item)[0]}
					>
						{(provided, snapshot) => (
							<div
								ref={provided.innerRef}
								style={getListStyle(snapshot.isDraggingOver)}
							>
								<h4 style={getTitleStyle(item.title.color)}>
									{item.title.text}
									{item.count > 0 && (
										<span style={getCountStyle()}>{item.count}</span>
									)}
									<span style={{ float: 'right' }}>
										{ativarMoverLote === true &&
											Object.keys(item)[0] !==
											quadroKanbanEnum.TM_PENDENTES.id &&
											Object.keys(item)[0] !==
											quadroKanbanEnum.TM_REVISADOS.id &&
											Object.keys(item)[0] &&
											Object.keys(item)[0] !== quadroKanbanEnum.HL_PRONTAS.id &&
											Object.keys(item)[0] !==
											quadroKanbanEnum.CG_PRONTAS.id && (
												<UncontrolledButtonDropdown className="mv-kanban-button">
													<DropdownToggle
														style={{
															backgroundColor: 'transparent',
															border: 'none',
														}}
													>
														<i className="fas fa-ellipsis-v" />
													</DropdownToggle>
													<DropdownMenu
														style={{
															marginLeft: '-165px',
															marginTop: '13px',
														}}
													>
														<DropdownItem>
															<Col
																sm="auto"
																className="menu-icone-kanban"
																onClick={() => onClikItem(item)}
															>
																<div
																	style={{ display: 'flex' }}
																	id={`loteItem_${item.id}`}
																	className="icone-Faturamento"
																>
																	<i className="mv-basico-sobrescrever" />
																	<span><IntlMessage id = "dashboards.cytology.sendBatch"/></span>
																</div>
																<UncontrolledTooltip
																	placement="top"
																	target={`loteItem_${item.id}`}
																>
																	<IntlMessage id = "dashboards.cytology.sendBatch"/>
																</UncontrolledTooltip>
															</Col>
														</DropdownItem>
													</DropdownMenu>
												</UncontrolledButtonDropdown>
											)}
									</span>
								</h4>

								<div className="kanban-lista">
									{item[Object.keys(item)[0]].map((_item, index) => (
										<Draggable
											isDragDisabled={_item.isDragDisabled}
											key={`item_${index}_${_item.id}`}
											draggableId={_item.id}
											index={index}
										>
											{(_provided, _snapshot) => (
												<div
													ref={_provided.innerRef}
													{..._provided.draggableProps}
													{..._provided.dragHandleProps}
													style={getItemStyle(
														_snapshot.isDragging,
														_provided.draggableProps.style,
														_item.isDragDisabled
													)}
												>
													{_item.content}
												</div>
											)}
										</Draggable>
									))}
								</div>
								{provided.placeholder}
							</div>
						)}
					</Droppable>
				))}
			</DragDropContext>
		</React.Fragment>
	);
}

export default DragDropComponente;



// WEBPACK FOOTER //
// ./src/componentes/dragdrog/dragdrop.componente.jsx